<template >
    <v-card  class="alternative-menu-popup rounded-0 pa-4">
        <div class="metrics">
            <v-list class="listreset text-none metric-list">
                <v-subheader class="pa-0  text-decoration-underline black--text h3">
                    {{ $t('utils.metricInformation') }}
                </v-subheader>
                <v-list-item
                    class="pa-0"
                    v-for="(metric, metricName) in metrics.metrics"
                    :key="metric.id + metricName"
                >
                    {{ metricName }} : <span class="pl-2" v-html="decodeHTMLfromString(metric)"/>
                </v-list-item>
            </v-list>
        </div>
    </v-card>
</template>

<script>
    export default{
        name: 'MetricsDialog',
        props:[
            'data',
            'metrics'
        ],
        methods: {
            decodeHTMLfromString(str){
                let decoder = document.createElement('textarea');
                decoder.innerHTML = str;
                return decoder.value;
            },
        }, 
    }
</script>

<style lang='scss' scoped>
    div.v-list.metric-list {
        > .v-list-item {
            min-height: unset;
        }
    }
</style>


// WEBPACK FOOTER //
// src/layout/alternative/plot/components/MetricsDialog.vue